export default [{
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_1.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_2.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_3.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_4.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_5.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_6.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_7.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_8.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_9.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_10.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_11.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_12.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_13.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_14.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_15.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_16.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_17.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_18.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_19.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_20.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_21.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_22.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_23.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_24.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_25.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_26.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_27.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_28.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_29.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_30.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_31.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_32.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_33.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_34.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_35.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_36.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_37.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_38.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_39.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_40.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_41.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_42.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_43.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_44.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_45.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_46.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_47.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_48.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_49.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_50.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_51.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_52.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_53.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_54.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_55.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_56.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_57.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_58.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_59.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_60.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_61.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_62.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_63.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_64.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_65.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_66.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_67.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_68.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_69.jpg"
}, {
  "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/history/15jie/15jie_70.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie15.js